import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import TimelineQueryCard from "../../charts/TimelineQueryCard";
import { offerUnsubscriptionsGroupByOfferQuery } from "../offerAnalytics.queries";
import { buildUnsubscriptionTimeline } from "../offerAnalytics.utils";

import type { JSX } from "react";

import type { GetOfferUnsubscriptionsGroupByOfferResponse } from "@/src/api/StatsAPI.types";

import type { ChartSeries, TimelineDatum } from "../../charts/charts.types";
import type {
  OfferAnalyticsFilterProps,
  UnsubscriptionSeriesKey,
} from "../offerAnalytics.types";

function buildTimeline(
  response: GetOfferUnsubscriptionsGroupByOfferResponse | undefined,
): TimelineDatum<UnsubscriptionSeriesKey>[] {
  return buildUnsubscriptionTimeline(response?.data ?? []);
}

function UnsubscriptionsTimelineCard({
  filters,
}: OfferAnalyticsFilterProps): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t } = useTranslation("editor-analytics");

  const seriesList = useMemo(
    (): ChartSeries<UnsubscriptionSeriesKey>[] => [
      {
        key: "voluntary",
        label: t("offerAnalytics.series.voluntary"),
        color: "var(--chart-1)",
      },
      {
        key: "automatic",
        label: t("offerAnalytics.series.automatic"),
        color: "var(--chart-2)",
      },
    ],
    [t],
  );

  return (
    <TimelineQueryCard
      buildTimeline={buildTimeline}
      endDate={filters.endDate}
      query={offerUnsubscriptionsGroupByOfferQuery(projectSlug, filters)}
      seriesList={seriesList}
      startDate={filters.startDate}
      title={t("offerAnalytics.charts.unsubscriptionsTimeline")}
    />
  );
}

export default UnsubscriptionsTimelineCard;
